export default function equippedItemLosses(messages, state) {
  return messages.filter(isEquippableItemLoss);

  function isEquippableItemLoss(message) {
    const { levelAfter, possession } = message;
    const { id } = possession;

    // If we have 1 or more of this quality, then we obviously haven't lost an equippable quality
    if (levelAfter > 0) {
      return false;
    }

    const { outfit } = state;

    // Check whether any slot currently has this item in it; if so, then
    // we have lost an equipped item
    return Object.keys(outfit).some(k => outfit[k] === id);
  }
}